/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const EYE_OFF_VIEWBOX = 17;

const EYE_OFF_PATH =
  'M7.45341 3.40341C7.74571 3.3586 8.04103 3.33632 8.33674 3.33674C10.9867 3.33674 13.4784 5.24508 14.9284 8.33674C14.7066 8.80724 14.4562 9.26365 14.1784 9.70341C14.0902 9.83992 14.0439 9.99923 14.0451 10.1617C14.0469 10.3436 14.1082 10.5199 14.2196 10.6636C14.331 10.8074 14.4864 10.9108 14.662 10.958C14.8377 11.0052 15.0239 10.9937 15.1924 10.9251C15.3609 10.8566 15.5023 10.7348 15.5951 10.5784C15.9833 9.96835 16.3206 9.32729 16.6034 8.66174C16.6481 8.55776 16.6712 8.44576 16.6712 8.33258C16.6712 8.21939 16.6481 8.10739 16.6034 8.00341C14.9201 4.09508 11.7534 1.67008 8.33674 1.67008C7.94563 1.66811 7.55515 1.70158 7.17008 1.77008C7.06064 1.78868 6.95594 1.82866 6.86196 1.88772C6.76797 1.94679 6.68654 2.02379 6.62231 2.11433C6.55809 2.20486 6.51232 2.30717 6.48763 2.41539C6.46294 2.52361 6.45981 2.63564 6.47841 2.74508C6.49701 2.85451 6.53699 2.95921 6.59606 3.0532C6.65512 3.14718 6.73212 3.22861 6.82266 3.29284C6.9132 3.35707 7.0155 3.40283 7.12372 3.42752C7.23195 3.45221 7.34397 3.45535 7.45341 3.43674V3.40341ZM1.42841 0.245076C1.35071 0.167378 1.25847 0.105743 1.15695 0.0636932C1.05543 0.021643 0.946626 0 0.836743 0C0.72686 0 0.618054 0.021643 0.516535 0.0636932C0.415017 0.105743 0.322775 0.167378 0.245076 0.245076C0.0881566 0.401996 0 0.614825 0 0.836743C0 1.05866 0.0881566 1.27149 0.245076 1.42841L2.82841 4.00341C1.64972 5.13802 0.711624 6.4984 0.0700763 8.00341C0.0241902 8.10855 0.000505646 8.22203 0.000505646 8.33674C0.000505646 8.45146 0.0241902 8.56494 0.0700763 8.67008C1.75341 12.5784 4.92008 15.0034 8.33674 15.0034C9.83433 14.9931 11.2966 14.5472 12.5451 13.7201L15.2451 16.4284C15.3225 16.5065 15.4147 16.5685 15.5163 16.6108C15.6178 16.6531 15.7267 16.6749 15.8367 16.6749C15.9468 16.6749 16.0557 16.6531 16.6108 16.4284C16.5065 16.3509 16.5685 16.2588 16.6108 16.1572C16.6531 16.0557 16.6749 15.9468 16.6749 15.8367C16.6749 15.7267 16.6531 15.6178 16.6108 15.5163C16.5685 15.4147 16.5065 15.3225 16.4284 15.2451L1.42841 0.245076ZM6.72841 7.90341L8.77008 9.94508C8.62923 9.98546 8.48325 10.0051 8.33674 10.0034C7.89472 10.0034 7.47079 9.82781 7.15823 9.51525C6.84567 9.20269 6.67008 8.77877 6.67008 8.33674C6.66837 8.19023 6.68802 8.04425 6.72841 7.90341ZM8.33674 13.3367C5.68674 13.3367 3.19508 11.4284 1.75341 8.33674C2.29182 7.1482 3.05597 6.07556 4.00341 5.17841L5.47841 6.67008C5.13195 7.30241 4.99986 8.03003 5.10196 8.74379C5.20406 9.45755 5.53484 10.119 6.04468 10.6288C6.55452 11.1386 7.21594 11.4694 7.9297 11.5715C8.64346 11.6736 9.37108 11.5415 10.0034 11.1951L11.3284 12.5034C10.421 13.0375 9.3896 13.3248 8.33674 13.3367Z';

/** Legacy / Figma default fill (previous hardcoded path fill). */
export const EYE_OFF_ICON_DEFAULT_FILL = '#6E7591';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Eye hidden / visibility off (17×17). Pass `aria-label` when meaning isn’t clear from nearby text.
 * Default `fill` matches previous asset color; use `currentColor` to follow CSS `color`.
 */
const EyeOffIcon = ({
  className = '',
  size = 17,
  fill = EYE_OFF_ICON_DEFAULT_FILL,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const { style: propsStyle, ...restProps } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${EYE_OFF_VIEWBOX} ${EYE_OFF_VIEWBOX}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      style={{ display: 'block', ...propsStyle, ...style }}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...restProps}
    >
      <path d={EYE_OFF_PATH} fill={fill} />
    </svg>
  );
};

EyeOffIcon.propTypes = {
  ...iconPropTypes,
  /** Any valid SVG fill; default is `EYE_OFF_ICON_DEFAULT_FILL`. */
  fill: PropTypes.string,
  style: PropTypes.shape({}),
};

export { EyeOffIcon };
export default EyeOffIcon;
